
import { useVideoDashboardStore } from './store';

/**
 * Helper hook to get videos filtered by active folder, search query, and status
 */
export const useFilteredVideos = () => {
  const { 
    videos,
    activeFolder,
    searchQuery,
    statusFilter,
    folders
  } = useVideoDashboardStore(state => ({
    videos: state.videos,
    activeFolder: state.activeFolder,
    searchQuery: state.searchQuery,
    statusFilter: state.statusFilter,
    folders: state.folders
  }));
  
  // Check if active folder is a newly created folder (has no videos)
  const activeFolder_hasVideos = activeFolder ? videos.some(v => v.folderId === activeFolder) : true;
  const isEmptyFolder = activeFolder && !activeFolder_hasVideos;
  
  return videos.filter(video => {
    // Filter by folder
    if (activeFolder) {
      // Special case: If folder is empty, show unassigned videos as potential candidates
      if (isEmptyFolder && video.folderId === null) {
        return true;
      } else if (video.folderId !== activeFolder) {
        return false;
      }
    }
    
    // Filter by search
    if (searchQuery && !video.title.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    
    // Filter by status
    if (statusFilter === 'processing' && video.status !== 'processing') {
      return false;
    }
    if (statusFilter === 'processed' && video.status !== 'processed') {
      return false;
    }
    
    return true;
  });
};

/**
 * Helper hook to get the count of new videos
 */
export const useNewVideosCount = () => {
  const videos = useVideoDashboardStore(state => state.videos);
  return videos.filter(video => video.isNew === true).length;
};
